import { render, staticRenderFns } from "./NextcloudSystem.vue?vue&type=template&id=9f1b66b2&scoped=true"
import script from "./NextcloudSystem.vue?vue&type=script&lang=js"
export * from "./NextcloudSystem.vue?vue&type=script&lang=js"
import style0 from "./NextcloudSystem.vue?vue&type=style&index=0&id=9f1b66b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1b66b2",
  null
  
)

export default component.exports